import { render, staticRenderFns } from "./CarteiraVacinacaoModal.vue?vue&type=template&id=3b7cc595&scoped=true&"
import script from "./CarteiraVacinacaoModal.vue?vue&type=script&lang=js&"
export * from "./CarteiraVacinacaoModal.vue?vue&type=script&lang=js&"
import style0 from "./CarteiraVacinacaoModal.vue?vue&type=style&index=0&id=3b7cc595&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7cc595",
  null
  
)

export default component.exports